import defaultPointTrackingDetailsTpl from './defaultPointTrackingDetails.tpl.html';

export default {
    templateUrl: defaultPointTrackingDetailsTpl,
    controller: 'defaultPointTrackingDetailsCtrl as vm',
    bindings: {
        details: '<'
    }
};
